import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer'
import styles from "../../../../layout/layoutHeader/components/styles";

const ShowOnHoverPopup = ({ classes, ...props }) => {
  return (
    <Tooltip title="Enable/Disable Show On Hover Popup">
      <div className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""}`}>
        <div className={classes.toggleText}>Show On Hover Popup </div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={props.toggleShowOnHoverPopup}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(ShowOnHoverPopup);
